import styles from './template.css';
import template from './template';
import {AoflElement, customElement} from '@aofl/element';
import {property} from 'lit-element';
import {ApiService} from './../api-service';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';

/**
 * @summary SearchExportButton
 * @extends {mapStatePropertiesMixin(AoflElement)}
 */
@customElement('search-export-button')
class SearchExportButton extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of SearchExportButton.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static get is() {
    return 'search-export-button';
  }

  @property({type: String})
  ['search-type'] = '';

  @property({type: String})
  ['search-namespace'] = '';

  @property({type: Array, attribute: false})
  tableConfig = [];

  @property({type: Array, attribute: false})
  results = [];

  @property({type: Array, attribute: false})
  filterIds = [];

  @property({type: Array, attribute: false})
  notSelected = [];

  @property({type: String, attribute: false})
  selectionMode = '';

  exportSearch = async (e) => {
    e.preventDefault();
    const searchState = storeInstance.getState()[this['search-namespace']];
    const {$search, $filters, $sort} = searchState;
    const promises = this.tableConfig.map((item) => item.label);
    const results = await Promise.all(promises);
    const fields = this.tableConfig.map((item, index) => {
      return {
        key: item.key,
        label: results[index].strings[0]
      };
    });
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = await ApiService.getDownloadRequestURL('search_download_export');
    const args = document.createElement('input');
    args.type = 'hidden';
    args.name = 'arguments';
    args.value = JSON.stringify({
      search_type: this['search-type'],
      search_params: {
        search: $search,
        filters: $filters,
        sort: $sort
      },
      fields,
      filter_ids: this.filterIds,
      not_selected: this.notSelected,
      selection_mode: this.selectionMode,
      i18n: [],
    });
    form.appendChild(args);

    document.body.appendChild(form);
    form.submit();
  };

  keyPressHandler = (e) => {
    if (e.key === 'Enter') {
      this.exportSearch();
    }
  }

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this.exportSearch);
    this.addEventListener('keypress', this.keyPressHandler);
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.exportSearch);
    super.disconnectedCallback();
  }
}

export default SearchExportButton;
